import { ComponentProps } from 'react';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Breadcrumb } from '@sorare/core/src/components/breadcrumb';
import { HELP } from '@sorare/core/src/constants/routes';

import { Search } from 'components/Search';

type Props = {
  sections?: ComponentProps<typeof Breadcrumb>['sections'];
};

export const Header = ({ sections }: Props) => {
  return (
    <Vertical>
      <SBHorizontal>
        <Breadcrumb rootTo={HELP} sections={sections} />
      </SBHorizontal>
      <Search />
    </Vertical>
  );
};
